import { createSlice } from '@reduxjs/toolkit';
import { ALERTS } from 'vio-constants';
import { resetApplication } from '../application/slice';
import modalAlertsState from './state';
export const modalAlertsSlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => modalAlertsState);
    },
    initialState: modalAlertsState,
    name: 'modalAlerts',
    reducers: {
        modalDanger: {
            prepare: message => {
                return {
                    payload: {
                        message
                    }
                };
            },
            reducer: (state, action) => {
                const { message } = action.payload;
                state.active.unshift({
                    alertType: ALERTS.DANGER,
                    message
                });
            }
        },
        modalDeleteAlert: {
            prepare: index => {
                return {
                    payload: {
                        index
                    }
                };
            },
            reducer: (state, action) => {
                const { index } = action.payload;
                state.active.splice(index, 1);
            }
        },
        modalInfo: {
            prepare: message => {
                return {
                    payload: {
                        message
                    }
                };
            },
            reducer: (state, action) => {
                const { message } = action.payload;
                state.active.unshift({
                    alertType: ALERTS.INFO,
                    message
                });
            }
        },
        modalResetAlerts: () => modalAlertsState,
        modalSuccess: {
            prepare: message => {
                return {
                    payload: {
                        message
                    }
                };
            },
            reducer: (state, action) => {
                const { message } = action.payload;
                state.active.unshift({
                    alertType: ALERTS.SUCCESS,
                    message
                });
            }
        }
    }
});
export const { modalDanger, modalDeleteAlert, modalInfo, modalResetAlerts, modalSuccess } = modalAlertsSlice.actions;
export default modalAlertsSlice.reducer;
